import { faCopyright } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import BannerImage from "../../../assets/images/bannerImage.png";
import { postContactDetails } from "../../../modules/contactUS/action";
import "../../../style";
import Button from "../../FormElement/Button";
import { validForm } from "../../FormElement/FormValidator";
import InputField from "../../FormElement/InputFiled";
import FeatureFour from "./FeatureFour";
import FeatureOne from "./FeatureOne";
import Features from "./Features";
import FeatureThree from "./FeatureThree";
import SubscriptionPlan from "./SubscriptionPlans";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      queryInfo: {},
      isValid: true,
      mandatoryFields: ["firstName", "lastName", "email", "message"]
    };
  }
  componentDidMount() {
    // this.props.actions.getAllContractList();
  }
  componentWillMount() {}

  handleChange = event => {
    const { name, value } = event.target;
    this.setState(
      prevState => {
        return {
          queryInfo: {
            ...prevState.queryInfo,
            [name]: value
          }
        };
      },
      () => {
        const { queryInfo } = this.state;
        this.setState({
          isValid: validForm({}, queryInfo)
        });
      }
    );
  };

  handleContactUs = () => {
    const { queryInfo } = this.state;
    this.props.actions.postContactDetails(queryInfo).then(data => {
      if (data) {
        this.setState({
          queryInfo: {
            firstName: "",
            lastName: "",
            email: "",
            message: ""
          }
        });
      }
    });
  };

  checkAllMandatoryCellsAreFilled = () => {
    const { mandatoryFields = [], queryInfo } = this.state;
    let blankCells = 0;
    blankCells = mandatoryFields.map(
      cell =>
        queryInfo[cell] === "" ||
        queryInfo[cell] === undefined ||
        queryInfo[cell] === null
    );
    return blankCells.includes(true);
  };

  render() {
    const { queryInfo, isValid } = this.state;
    return (
      <div>
        <section>
          <div className="imageBanner">
            <img src={BannerImage} style={{ width: "100%" }} />
            <div class="text-block">
              <h1>Welcome to NTRAC</h1>
              <p>
                A software solution for farmers to simplify harvest tracking and
                get paid faster.
              </p>
            </div>
          </div>
        </section>
        <section className="featuresSection">
          <div className="homeFeatures">
            <h1 className="featureHeader">Our features</h1>
            <h3 className="contentDescription">
              The NTRAC harvest solution creates a single entry point that helps
              standardize inputs, reduce errors, track harvest activity, manage
              contract details, and put you in control of your yield data.
            </h3>
          </div>
          <div className="featureCards">
            <Grid container spacing={12}>
              <Features />
              <FeatureOne />
              <FeatureThree />
              <FeatureFour />
            </Grid>
          </div>
        </section>
        <section className="subscriptionSection">
          <div className="homeSubscription">
            <h1 className="featureHeader">Our Plans</h1>
            {/* <h3 className="contentDescription">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt.
            </h3> */}
          </div>
          <div className="subscriptionCards">
            <SubscriptionPlan />
          </div>
        </section>
        <section className="ConnectSection" id="ConnectSection">
          <div className="homeConnect">
            <h1 className="connectHeader">Contact us for more info</h1>
            {/* <h3 className="contentDescription">
              A telescope is a big step into the lifelong hobby of astronmy.
            </h3> */}
            <Grid container spacing={8}>
              <Grid item sm={6} xs={12}>
                <span style={{ color: "#fff" }}>First name *</span>
                <InputField
                  placeholder="Name"
                  styleClass="styleClass"
                  type="text"
                  required
                  name="firstName"
                  validations={["required"]}
                  handleChange={this.handleChange}
                  value={queryInfo.firstName}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <span style={{ color: "#fff" }}>Last name *</span>
                <InputField
                  placeholder="Name"
                  styleClass="styleClass"
                  type="text"
                  required
                  name="lastName"
                  validations={["required"]}
                  handleChange={this.handleChange}
                  value={queryInfo.lastName}
                />
              </Grid>
              <Grid item sm={12} xs={12}>
                <span style={{ color: "#fff" }}>Email *</span>
                <InputField
                  placeholder="Email/Username"
                  styleClass="styleClass"
                  type="email"
                  name="email"
                  required
                  validations={["email", "required"]}
                  value={queryInfo.email}
                  handleChange={this.handleChange}
                />
              </Grid>
              <Grid item sm={12} xs={12}>
                <span style={{ color: "#fff" }}>Message *</span>
                <InputField
                  placeholder="Write your message"
                  type="text"
                  styleClass="styleClass"
                  multiline
                  name="message"
                  required
                  value={queryInfo.message}
                  validations={["required"]}
                  handleChange={this.handleChange}
                  rows={2}
                  rowsMax={4}
                />
              </Grid>
              <div className="buttonContainer">
                <Button
                  name="Send message"
                  disabled={isValid || this.checkAllMandatoryCellsAreFilled()}
                  onclick={this.handleContactUs}
                />
              </div>
            </Grid>
            <h3 className="contentDescription" style={{ color: "#e1ebec" }}>
              Contact us to learn more today: novustrac.com | (620) 518-2069!
            </h3>
          </div>
        </section>
        <section className="footerSection">
          <FontAwesomeIcon icon={faCopyright} className="copyrightSvg" />
          <span className="copyrightText">
            {new Date().getFullYear()} NTRAC. All rights reserved.
          </span>
          <div style={{}}>
            <Link
              style={{
                color: "#fff",
                textDecoration: "underline",
                paddingTop: "5px"
              }}
              to="privacy"
            >
              Privacy Policy
            </Link>
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    contactInfo: state.contactUSReducer.ContactInfo
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        postContactDetails
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/public/Home/Home.js